export default "__VITE_ASSET__$KMIN932__"